import commonMutations from '@/store/data/common/mutations'

export default commonMutations
